var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyPageIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21395",
    "data-name": "\\uADF8\\uB8F9 21395",
    transform: "translate(0 -0.22)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_27602",
    "data-name": "\\uC0AC\\uAC01\\uD615 27602",
    width: 32,
    height: 32,
    transform: "translate(0 0.22)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21394",
    "data-name": "\\uADF8\\uB8F9 21394",
    transform: "translate(3.783 3.726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10125",
    "data-name": "\\uD328\\uC2A4 10125",
    d: "M178.23,22.24a12.2,12.2,0,1,1-12.195-12.195A12.195,12.195,0,0,1,178.23,22.24Z",
    transform: "translate(-153.839 -10.045)",
    fill: "none",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    id: "P",
    transform: "translate(6.195 19.39)",
    fill: "#343a40",
    fontSize: 18,
    fontFamily: "Helvetica-Bold, Helvetica",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "P"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPageIcon3);
export default __webpack_public_path__ + "static/media/myPageIcon3.e01beb36be63e1588f9fcd6ce5430fff.svg";
export { ForwardRef as ReactComponent };